import Vue from "vue"
import VueI18n from "vue-i18n"
import { getNavLanguage } from "@/utils/deviceDetect"
import de from "./lang/de.js"
import en from "./lang/en.js"
import es from "./lang/es.js"
import fr from "./lang/fr.js"
import zh from "./lang/zh.js"
Vue.use(VueI18n)

const messages = { en, zh, de, fr, es }

const i18n = new VueI18n({
  locale: localStorage.getItem("language") || getNavLanguage() || "en",
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/locale/index.js